import {
  maintenanceWorkOrderListQuerySchema,
  type MaintenanceWorkOrderListQuery,
} from '@gb-ticket/shared-types';

import { toSearchParams } from '@/lib/format';
import { MAINTENANCE_ROOT } from '@/products/maintenance/maintenance-paths';

export const DEFAULT_MAINTENANCE_HOME_ORDERS_QUERY: MaintenanceWorkOrderListQuery = {
  page: 1,
  pageSize: 25,
  sortBy: 'scheduledFor',
  sortOrder: 'asc',
  includeArchived: false,
};

export function maintenanceHomeOrdersPath(
  patch: Partial<MaintenanceWorkOrderListQuery> = {},
): string {
  const query = { ...DEFAULT_MAINTENANCE_HOME_ORDERS_QUERY, ...patch };
  return `${MAINTENANCE_ROOT}${toSearchParams({
    page: query.page,
    pageSize: query.pageSize,
    sortBy: query.sortBy,
    sortOrder: query.sortOrder,
    status: query.status,
    scheduledFrom: query.scheduledFrom,
    scheduledTo: query.scheduledTo,
    includeArchived: query.includeArchived ? true : undefined,
  })}`;
}

export function maintenanceHomeOrdersQueryFromSearch(
  search: string,
): MaintenanceWorkOrderListQuery {
  const params = {
    page: String(DEFAULT_MAINTENANCE_HOME_ORDERS_QUERY.page),
    pageSize: String(DEFAULT_MAINTENANCE_HOME_ORDERS_QUERY.pageSize),
    sortBy: DEFAULT_MAINTENANCE_HOME_ORDERS_QUERY.sortBy,
    sortOrder: DEFAULT_MAINTENANCE_HOME_ORDERS_QUERY.sortOrder,
    ...Object.fromEntries(new URLSearchParams(search)),
  };
  const parsed = maintenanceWorkOrderListQuerySchema.safeParse(params);
  return parsed.success ? parsed.data : DEFAULT_MAINTENANCE_HOME_ORDERS_QUERY;
}
